export const LoadingState = {
    EMPTY: 'empty',
    LOADING: 'loading',
    LOADED: 'loaded',
    FAILED: 'failed',
};